<template>
    <el-card class="reportsList">
        <div style=" font-size: 16px;
        font-weight: 900;">事件经理</div>
        <ul>
            <router-link :to="{path:'/eventToPro'}">
                <li>事件转问题的数量</li>
            </router-link>
            <router-link :to="{path:'/bigEventManage'}">
                <li>事件经理协助处理重大和超SLA事件</li>
            </router-link>
            <router-link :to="{path:'/collectAndBypass'}">
                <li>绕过服务台数和补录事件数</li>
            </router-link>

            <!--<router-link :to="{path:'/satisfactionRate'}">-->
                <!--<li>客户满意度合格率</li>-->
            <!--</router-link>-->
            <!--<router-link :to="{path:'/exceedSLA'}">-->
                <!--<li>超出SLA的事件的数量</li>-->
            <!--</router-link>-->
        </ul>
    </el-card>
</template>

<script>
    export default {
        name: "firstLineEvent"
    }
</script>

<style scoped>
    .reportsList{
        /*height: 120px;*/
        background: white;
        font-size: 15px;
    }
    .reportsList div{
        padding-left: 15px;
    }
    .reportsList ul{
        float: left;
        margin: 20px 10px 10px 10px;

    }
    .reportsList ul li{
        color: grey;
        float: left;
        margin: 5px 35px 5px 5px;
    }
</style>
